import moment from 'moment'

function getDays(n) {
  let days = []
  for (let i = 0; i < n; i ++) {
    days.push(moment().add(i, 'days').format('YYYY-MM-DD'))
  }
  return days.join(',')
}

export default getDays